import { JobCommoditySearchRequest } from '@trukt/tms-api/JobService';
import { createKey } from '../../createKey';

const keyHandler = createKey('job-commodity');

export const JobCommodityServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<JobCommoditySearchRequest>(),
};
